import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';
import CenteredBox from '@/app/base-ui/CenterBox';
import BaseModal from '@/app/base-ui/BaseModalUI';

interface ActionButtonsProps {
    onEditUrl?: () => void;
    onDeleteUrlCurrent?: () => void;
}

const ButtonHandleUrl: React.FC<ActionButtonsProps> = ({ onEditUrl, onDeleteUrlCurrent }) => {
    const [confirmPopup, setConfirmPopup] = useState(false);
    const handleDeleteUrl = async () => {
        setConfirmPopup(true)
    };
    const handleAccept = () => {
        onDeleteUrlCurrent?.()
        setConfirmPopup(false)
    }

    const handleEdit = () => {
        onEditUrl?.()
    }
    return (
        <>
            <CenteredBox sx={{ justifyContent: 'center', width: '100%', gap: 1.25 , zIndex: 999}}>
                <Button
                    sx={{
                        backgroundColor: 'background.default',
                        color: 'grayscale.gray07',
                        width: 'fit-content',
                        borderRadius: '15px',
                        padding: '6px 12px',
                        minWidth: '47px',
                        textTransform: 'unset',
                        minHeight: 24,
                        border: '1px solid var(--text-gray-07000, #000)',
                        '&:hover': {
                            backgroundColor: 'background.default',
                            opacity: 0.9,
                        },
                    }}
                    onClick={() => handleDeleteUrl()}
                >
                    <Typography
                        variant="h2_12Medium"
                        lineHeight="100%"
                    >
                        삭제
                    </Typography>
                </Button>

                <Button
                    sx={{
                        backgroundColor: 'secondary.main',
                        color: 'grayscale.gray07',
                        padding: '6px 12px',
                        minWidth: '47px',
                        borderRadius: '15px',
                        textTransform: 'unset',
                        minHeight: 24,
                        border: '1px solid var(--text-gray-07000, #000)',
                        '&:hover': {
                            backgroundColor: 'secondary.main',
                            opacity: 0.9,
                        },
                    }}
                    onClick={() => handleEdit()}
                >
                    <Typography
                        variant="h2_12Medium"
                        lineHeight="100%"
                    >
                        수정
                    </Typography>
                </Button>
            </CenteredBox>
            {confirmPopup && (
                <BaseModal
                    open={confirmPopup}
                    onClose={() => setConfirmPopup(false)}
                    title={`첨부된 영상 등록을 삭제하시겠습니까?<br />삭제 후 새로운 미디어를 등록하셔야 합니다.`}
                    description={''}
                    showCancel
                    showAccept
                    onCancel={() => setConfirmPopup(false)}
                    onAccept={handleAccept}
                    cancelText="취소"
                    acceptText="삭제"
                ></BaseModal>
            )}
        </>
    );
};

export default ButtonHandleUrl;
